import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { API_BASE_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";

export default function Orders() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [expensesData, setExpensesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { setID } = useLabelContext();
  const [ordersData, setOrdersData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [userDataSession, setUserDataSession] = useState({});
  const [selectedStore, setSelectedStore] = useState("0");
  const [MisUserDetails, SetUserDetails] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");

  useEffect(() => {
    const today = new Date();

    // Function to format date as YYYY-MM-DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero
      const day = String(date.getDate()).padStart(2, "0"); // Add leading zero
      return `${year}-${month}-${day}`;
    };

    const currentToDate = formatDate(today);

    const currentFromDate = formatDate(
      new Date(today.getFullYear(), today.getMonth(), 1)
    );

    setToDate(currentToDate);
    setFromDate(currentFromDate);
  }, []);

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      const fetchStoresData = async () => {
        try {
          const response = await fetch(
            `${API_BASE_URL}Settings/getUserStores?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
          );
          if (response.ok) {
            const data = await response.json();
            if (data) {
              setStoreData(data.ResultData);
            } else {
              console.error("Error fetching data: No result data");
            }
          } else {
            console.error("Error fetching data: ", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchStoresData();
    }
  }, [userDataSession]);

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };
  console.log(fromDate, "from date");
  const handleToDateChange = (e) => {
    setToDate(e.target.value);
  };

  const fetchOrders = async () => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      const params = new URLSearchParams({
        OrgId: userDataSession.OrgId,
        STdt: fromDate || null,
        enddt: toDate || null,
        PosId: 0,
        OrderNo: 0,
        StoreId: selectedStore || 0,
      });
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getOrders?${params.toString()}`
        );
        const data = await response.json();

        if (response.ok && data.Status) {
          if (Array.isArray(data.ResultData) && data.ResultData.length > 0) {
            if (data.ResultData[0].Status !== "Failure") {
              setOrdersData(data.ResultData);
            } else {
              console.error(
                "Error fetching data:",
                data.ResultData[0].ResultMessage
              );
              setOrdersData([]);
            }
          } else {
            setOrdersData([]);
          }
        } else {
          console.error(
            "Error fetching data:",
            data?.ResultMessage || "Unknown error"
          );
          setOrdersData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setOrdersData([]);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [userDataSession]);

  const handlesearch = () => {
    fetchOrders();
  };

  const handleReload = () => {
    window.location.reload();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = ordersData.filter(
      (item) =>
        (item.StoreName &&
          item.StoreName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.OrderNo &&
          item.OrderNo.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    setCurrentPage(1);

    return results;
  }, [ordersData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleChange = (event) => {
    setSelectedStore(event.target.value);
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-2">
            <h4>Orders</h4>
            <h6>Manage Your Orders</h6>
          </div>
          <div className="search-bar mb-2 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <button
              onClick={() => setIsFilterVisible(!isFilterVisible)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              <i
                className="fa fa-filter"
                style={{ fontSize: "24px", color: "#333" }}
              ></i>
            </button>
          </div>
        </div>
      </div>

      <div>
        {isFilterVisible && (
          <div className="row g-3 mb-3 align-items-end">
            <div className="col-6 col-md-3 col-lg-3">
              <label className="form-label">From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={handleFromDateChange}
              />
            </div>

            <div className="col-6 col-md-3 col-lg-3">
              <label className="form-label">To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={handleToDateChange}
              />
            </div>

            <div className="col-8 col-md-3 col-lg-3">
              <label className="form-label">Store</label>
              <select
                id="store-dropdown"
                className="form-select"
                value={selectedStore}
                onChange={handleChange}
              >
                <option value="0">-- All --</option>
                {storeData.map((store) => (
                  <option key={store.StoreId} value={store.StoreId}>
                    {store.Name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-4 col-md-3 col-lg-3 ">
              <button
                className="btn  w-10"
                onClick={handlesearch}
                disabled={loading}
                style={{ backgroundColor: "#0c1978" }}
              >
                <i
                  class="fa-solid fa-magnifying-glass"
                  style={{ color: "white" }}
                ></i>
              </button>
            </div>
          </div>
        )}
      </div>
      <br></br>

      <div className="card-container mb-3" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : currentItems && currentItems.length > 0 ? (
          <div className="row">
            {currentItems.map((item, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div
                  className="supplier-card card shadow-sm mb-2"
                  style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                >
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span
                        className="card-titl"
                        style={{ color: "#007bff", fontSize: "1.2rem" }}
                      >
                        {item.StoreName}
                      </span>
                      <span style={{ color: "#6c757d" }}>
                        <i
                          className="fa-solid fa-calendar-alt"
                          style={{ color: "#007bff", marginRight: "5px" }}
                        ></i>
                        {formatDate(item.OrderDate)}
                      </span>
                    </div>
                    <div
                      className="card-details"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "10px",
                        fontSize: "0.9rem",
                      }}
                    >
                      {[
                        { icon: "fa-user", label: item.CustomerName || "N/A" },
                        { icon: "fa-list", label: item.OrderNo },
                        { icon: "fa-dollar-sign", label: item.Total },
                        { icon: "fa-cash-register", label: item.POSName },
                      ].map((data, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <span>
                            <i
                              className={`fa-solid ${data.icon}`}
                              style={{ color: "#007bff", marginRight: "5px" }}
                            ></i>
                            {data.label}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center my-5">
            <p>No Data Available</p>
          </div>
        )}

        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={filteredItems.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>

      <br />
      <br />
      <br />

      <Footer></Footer>
    </Base>
  );
}
